import type { HTMLAttributes } from 'react';

export enum MStarGroupSize {
  S = 'S',
  M = 'M',
  L = 'L',
}

export interface MStarGroupProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  rating: number;
  /** MStarGroup S → AIcon XS; M → S; L → M. */
  size?: MStarGroupSize;
}
